import { render, staticRenderFns } from "./web_up.vue?vue&type=template&id=401f6638&scoped=true"
import script from "./web_up.vue?vue&type=script&lang=js"
export * from "./web_up.vue?vue&type=script&lang=js"
import style0 from "./web_up.vue?vue&type=style&index=0&id=401f6638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401f6638",
  null
  
)

export default component.exports